import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircleFilled, StopOutlined, WarningFilled } from "@ant-design/icons";
import { useTranslation } from "../../../../../others/i18n.js";
import { spacing } from "../../../../../styles/spacing.js";
function TranslationInfoState(props) {
    const { t } = useTranslation();
    const { isComplete } = props;
    if (isComplete !== undefined) {
        if (isComplete) {
            return /*#__PURE__*/ _jsx(CheckCircleFilled, {
                style: {
                    color: "green",
                    marginLeft: spacing.layout.content.marginSmall,
                    marginRight: spacing.layout.content.marginSmall
                },
                title: t("Complete")
            });
        } else {
            return /*#__PURE__*/ _jsx(WarningFilled, {
                style: {
                    color: "orange",
                    marginLeft: spacing.layout.content.marginSmall,
                    marginRight: spacing.layout.content.marginSmall
                },
                title: t("Incomplete")
            });
        }
    } else {
        return /*#__PURE__*/ _jsx(StopOutlined, {
            style: {
                color: "grey",
                marginLeft: spacing.layout.content.marginSmall,
                marginRight: spacing.layout.content.marginSmall
            },
            title: t("No Data")
        });
    }
}
export { TranslationInfoState };
